import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import http from '../../Store/baseHttp';
import ResponseObject from '../../DataObjects/ResponseObject';
import UserObject from '../../DataObjects/UserObject';

// Simple loader component
function Loader({ message }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <div>
        <div className="spinner" /> {/* Replace with your spinner if you have one */}
        <p>{message}</p>
      </div>
    </div>
  );
}

function safeRedirect(url) {
  return url?.startsWith('/') ? url : '/dashboard';
}

export default function ThirdPartyAuth() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true; // Prevent state updates if unmounted

    const query = new URLSearchParams(location.search);
    const token = query.get('token');
    const redirectUrl = query.get('redirectTo') || '/dashboard';

    if (!token) {
      navigate('/login', { replace: true });
      return;
    }

    async function authenticate() {
      try {
        let response = await http.get("/user/token/refresh", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        let res = ResponseObject.from(await response);

        if (res?.success && res?.data) {
            let user =  UserObject.from(await res.data);
          // Always clear the user info before storing the new one
          localStorage.removeItem('user');
           user.storeUser();
          if (isMounted) {
            setLoading(false);
            navigate(safeRedirect(redirectUrl), { replace: true });
          }
        } else {
          throw new Error('Invalid user data');
        }
      } catch (error) {
        console.error('Token verification failed:', error);
        if (isMounted) {
          setLoading(false);
          navigate('/login?error=invalid_token', { replace: true });
        }
      }
    }

    authenticate();

    return () => {
      isMounted = false;
    };
  }, [navigate, location.search]);

  // Loader is shown while authenticating
  return loading ? <Loader message="Authenticating..." /> : null;
}